import { render, staticRenderFns } from "./SelectAuthMethod.component.html?vue&type=template&id=2685ee97&scoped=true&"
import script from "./SelectAuthMethod.component.ts?vue&type=script&lang=ts&"
export * from "./SelectAuthMethod.component.ts?vue&type=script&lang=ts&"
import style0 from "./SelectAuthMethod.component.scss?vue&type=style&index=0&id=2685ee97&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2685ee97",
  null
  
)

export default component.exports